import React, { useState, useEffect, useRef } from "react";

function EditableCell({
  value,
  onSave,
  type = "text",
  options = [],
  isEditing,
  onStartEdit,
  onCancelEdit,
  align = "left",
  formatValue = (v) => v,
  parseValue = (v) => v,
  className = "",
}) {
  const [editValue, setEditValue] = useState(value || "");
  const inputRef = useRef(null);
  const datalistId = useRef(
    `datalist-${Math.random().toString(36).substr(2, 9)}`
  );

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      // Chỉ select text nếu là input, không phải select
      if (inputRef.current.tagName === 'INPUT' && inputRef.current.select) {
        inputRef.current.select();
      }
    }
  }, [isEditing]);

  useEffect(() => {
    // Khi bắt đầu edit, chuyển từ format về số thuần để dễ chỉnh sửa
    if (isEditing) {
      if (typeof value === "number") {
        setEditValue(value.toString());
      } else if (typeof value === "string" && value.includes("đ")) {
        // Nếu có format tiền tệ, parse về số thuần
        const num = Number(value.replace(/[^\d-]/g, "")) || "";
        setEditValue(num.toString());
      } else {
        setEditValue(value || "");
      }
    } else {
      setEditValue(value || "");
    }
  }, [value, isEditing]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSave();
    } else if (e.key === "Escape") {
      setEditValue(value || "");
      onCancelEdit();
    }
  };

  const handleSave = () => {
    const parsed = parseValue(editValue);
    onSave(parsed);
  };

  const handleBlur = () => {
    handleSave();
  };

  if (!isEditing) {
    return (
      <td
        className={`px-3 py-2 whitespace-nowrap text-xs text-slate-700 cursor-cell hover:bg-blue-50 ${
          align === "right"
            ? "text-right"
            : align === "center"
            ? "text-center"
            : "text-left"
        } ${className}`}
        onDoubleClick={onStartEdit}
        onClick={onStartEdit}
        title={formatValue(value) || ""}
      >
        {formatValue(value)}
      </td>
    );
  }

  return (
    <td
      className={`px-3 py-2 whitespace-nowrap ${
        align === "right"
          ? "text-right"
          : align === "center"
          ? "text-center"
          : "text-left"
      } ${className}`}
    >
      {options.length > 0 ? (
        <select
          ref={inputRef}
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          className="w-full px-2 py-1 text-xs border-2 border-blue-500 rounded focus:outline-none bg-white"
        >
          <option value="">-- Chọn --</option>
          {options.map((opt, idx) => (
            <option key={idx} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      ) : (
        <input
          ref={inputRef}
          type={type}
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          className="w-full px-2 py-1 text-xs border-2 border-blue-500 rounded focus:outline-none"
        />
      )}
    </td>
  );
}

export default EditableCell;

